export const TL_GREEN = '#339933'
export const TL_YELLOW = '#979933'
export const TL_GRAY = '#ced4da'
export const TL_MUTED = '#adb5bd'

/** Etapa em que o produto estava quando foi mandado para correção (status 9). */
export function correctionStopStep(produto) {
  const n = Number(produto?.prodStatusPenultimo_id)
  if (n >= 3 && n <= 8) return n
  return 2
}

/** Verde até Em Elaboração (2); amarelo até a etapa em que parou; o resto fica inativo. */
export function correctionMark(step, produto) {
  const stop = correctionStopStep(produto)
  if (step <= 2) return 'green'
  if (step <= stop) return 'yellow'
  return 'idle'
}

export function correctionSegmentColor(step, side, produto) {
  if (side === 'left' && step === 1) return 'transparent'
  if (side === 'right' && step === 8) return 'transparent'
  const far = side === 'left' ? step : step + 1
  const stop = correctionStopStep(produto)
  if (far <= 2) return TL_GREEN
  if (far <= stop) return TL_YELLOW
  return TL_GRAY
}
